import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';
import Share from './share';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { channel, downloads, docData, interact, searchAd } = this.props.content;
        const title = channel.title ? `${channel.title}频道` : '大风号';

        return (
            <header className={styles.header}>
                <div className={styles.box}>
                    <div className={styles.title_box}>
                        <a href="//i.ifeng.com" className={styles.logo} />
                        <h2 className={styles.channelName}>
                            <a href={channel.url}>{title}</a>
                        </h2>
                    </div>
                    <div className={styles.searchBox}>
                        <NoSSR>
                            <Ad content={searchAd} />
                        </NoSSR>
                    </div>
                    {!interact?.isCloseShare && <Share docData={docData} content={downloads} />}
                </div>
            </header>
        );
    }
}

export default errorBoundary(Header);
